<app-modal [modalConfig]="modalConfig">
    <div class="row j-c" *ngIf="searchResponse && searchResponse.results.length > 0; else noDataTemplate">
        <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 mt-2" *ngFor="let board of searchResponse?.results">
            <div class="card h-100">
                <div class="card-body d-flex flex-column">
                    <span class="fs-18"
                        ><strong>{{ board?.nombre | slice : 0 : 25 | titlecase }}{{ (board?.nombre?.length || 0) > 25 ? '...' : '' }}</strong></span
                    >
                    <span class="fs-16">{{ board?.descripcion | slice : 0 : 25 | titlecase }}{{ (board?.descripcion?.length || 0) > 25 ? '...' : '' }}</span>
                    <textarea class="card-textarea flex-grow-1 m-b-15" readonly>{{ board?.texto | slice : 0 : 100 }}{{ (board?.texto?.length || 0) > 100 ? '...' : '' }}</textarea>
                    <div class="text-center mt-auto">
                        <a class="btn btn-orange" (click)="redirectResult(board)">Abrir</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #noDataTemplate>
        <div class="d-flex flex-column align-items-center justify-content-center p-4">
            <img src="assets/icons/empty.svg" alt="Like" width="20%" />
            <p class="fs-18">No se encontraron resultados para la búsqueda.</p>
        </div>
    </ng-template>
</app-modal>
